<template>
  <div class="form">
    <div class="row">
      <label>
        Name
        <span class="req">*</span>
      </label>
      <input class="txt" type="txt" v-model="form.name" />
    </div>
    <div class="row">
      <label>
        Telephone
        <span class="req">*</span>
      </label>
      <input class="txt" type="tel" v-model="form.telephone" />
    </div>
    <div class="row">
      <label>Email <span class="req">*</span></label>
      <input class="txt" type="email" v-model="form.email" />
    </div>
    <div class="row">
      <label>File</label>
      <input @change="onFileSelected" class="txt" id="uploadFile" type="file" />
    </div>
    <div class="row">
      <label>
        Message
        <span class="req">*</span>
      </label>
      <textarea class="txt" v-model="form.message"></textarea>
    </div>
    <div class="row">
      <span class="success" v-show="emailsuccess"
        >Thank you, your request has been sent and we'll be in touch soon.</span
      >
      <span class="error" v-show="emailerror">{{ errormessage }}</span>
      <button @click="sendEmail"><i class="fa fa-send"></i> Submit enquiry</button>
    </div>
  </div>
</template>

<script>
import api from "@/services/api"
import { mapState } from "vuex"
import validDataUrl from "valid-data-url"

export default {
  name: "Form",
  data: function () {
    return {
      emailsuccess: false,
      emailerror: false,
      errormessage: "",
      form: {},
      initial_values: { file: [] }
    }
  },
  computed: {
    ...mapState(["page"])
  },
  created: function () {
    this.form = JSON.parse(JSON.stringify(this.initial_values))
  },
  methods: {
    onFileSelected(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      const reader = new FileReader()
      reader.readAsDataURL(files[0])
      reader.onload = () => {
        var file = reader.result
        var parts = file.trim().match(validDataUrl.regex)

        this.form.file.push({
          // content: parseDataUrl(reader.result).data,
          content: parts[parts.length - 1] || "",
          type: files[0].type,
          filename: files[0].name,
          disposition: "attachment"
        })
      }
      reader.onerror = (error) => console.log(error)
    },
    sendEmail: function () {
      this.emailsuccess = false
      this.emailerror = false

      if (!this.form.name || !this.form.telephone || !this.form.message || !this.form.email) {
        this.errormessage = "Please fill in all required fields, thanks!"
        this.emailerror = true
        return false
      }

      const self = this
      self.status = "submitting"

      var content = `The following message has been sent from the website:<br /><br />`

      content += `Name: ${this.form.name}<br />
                  Telephone: ${this.form.telephone}<br />
                  Email: ${this.form.email}<br />`

      if (this.form.message) content += `Message: ${this.form.message}<br />`

      api
        .sendEmail("Enquiry from the website", content, this.form.file)
        .then(() => {
          this.emailsuccess = true
          this.form = JSON.parse(JSON.stringify(this.initial_values))
          document.getElementById("uploadFile").value = ""
        })
        .catch(() => {
          this.errormessage = "There has been an error submiting your message"
          this.emailerror = true
        })
    }
  }
}
</script>

<style scoped>
.form {
  padding-top: 6rem;
}

.row {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  width: 100%;
  display: table;
}

textarea {
  height: 8rem;
}

.txt {
  border: 1px solid #d5d5d5;
  width: 30rem;
  padding: 1rem;
  float: left;
}

.row label {
  display: block;
  float: left;
  width: 20rem;
  padding-top: 0.5rem;
  color: #f79227;
}

.req {
  color: #333;
}

button {
  margin-left: 20rem;
  border: 0;
  background: #434f50;
  color: white;
  padding: 1rem 2rem;
  cursor: pointer;
  transition: all 0.2s;
}

button i {
  margin-right: 0.5rem;
  color: #f79227;
}

button:hover {
  transform: scale(1.05);
}

.error,
.success {
  display: block;
  clear: both;
}

@media screen and (max-width: 950px) {
  .form {
    padding-top: 0;
  }
  .row label {
    width: 30%;
    padding-right: 5%;
  }
  .row .txt {
    width: 65%;
  }
  button {
    margin-left: 30%;
  }
}
</style>
